import { useParams } from "react-router";

import { useConnectedAccountsQuery } from "shared/api/use-connected-accounts-query";
import { Spinner } from "shared/ui/spinner";

import { Content } from "./content";

export const Account = () => {
  const { name } = useParams<{ name: string }>();
  const query = useConnectedAccountsQuery({ name: name }, { staleTime: 0 });

  if (query.isPending)
    return (
      <div className="flex min-h-dvh grow items-center justify-center">
        <Spinner />
      </div>
    );
  if (query.isError) return <div>Error...</div>;

  const account = query.data.connected_accounts[0];
  if (!account) return <div>Account not found</div>;

  return <Content account={account} />;
};
